import type { PagesConfig } from '#types/config/pages'

export default {
  supportedLocales: ['en-gb', 'en-ie', 'nl-nl', 'fr-fr', 'es-es', 'de-de', 'it-it']
} satisfies PagesConfig['loyaltyProgramme']
